/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
//import { VappRequestProcessor } from "../StateMachineService";
import { GetCatagoryListProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "CarnivalCatagoryPageService";
const log: any = LoggerModule.getInstance();

export class CarnivalCatagoryPageService {
  private static instance: CarnivalCatagoryPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private criteria: any;

  private constructor(props: any = {}) {
    //super();
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): CarnivalCatagoryPageService {
    if (!CarnivalCatagoryPageService.instance) {
      CarnivalCatagoryPageService.instance = new CarnivalCatagoryPageService(
        props
      );
    }
    return CarnivalCatagoryPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getCatagoryList(args: GetCatagoryListProps) {
    let _args = {
      ...args,
    };
    const agent = getAgent();
    return agent.getCatagoryList(_args);
  }
}
